import React from "react";
import { Form, Formik, Field } from "formik";
import { ApiService } from "../../../../../services/ApiService";
import lodash from "lodash";

export default function EditrequestModal({
  closeModal,
  requestType,
  getAllRequest,
  approveRequest,
  SetRejectState,
  setOpenReject,
  value,
  alert,
  officeRequestsCategories,
  individualRequestsCategories,
  user,
}) {
  const rejectRqt = () => {
    SetRejectState([value.request_id]);
    closeModal();
    setOpenReject(true);
  };

  return (
    <React.Fragment>
      <h4 style={{ color: "#000" }}>Edit Office Request</h4>
      <Formik
        initialValues={{
          request_type: value.request_type,
          description: value.description,
          price: value.price,
          request_id: value.request_id,
          request_category: value.request_category,
        }}
        onSubmit={async (values, { setSubmitting }) => {
          const isNotSame = lodash.isEqual(value, values);

          console.log("isSame", isNotSame);
          if (!isNotSame) {
            const res = await ApiService.post(
              `requests/update-request/${value.request_id}`,
              values
            );

            if (res.data.type === false) {
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
            }
          }

          getAllRequest();
          user.roles && user.roles.name === "admin"
            ? approveRequest(value.request_id)
            : null;
          closeModal();
        }}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Request Type <span className="text-danger"> * </span>
                  </label>
                  <Field
                    name="request_type"
                    as="select"
                    className="form-control select2 required"
                  >
                    <option>--Select Request Type--</option>
                    {requestType.map((request, i) => (
                      <option value={request.id} key={i}>
                        {request.name}
                      </option>
                    ))}
                  </Field>
                </div>
              </div>
            </div>
            {values.request_type !== "" ? (
              <div className="form-group">
                <label>
                  {values.request_type.toString() === "2"
                    ? "Sub Office Categories"
                    : "Sub Individual Categories"}{" "}
                  <span className="text-danger"> * </span>
                </label>
                <Field
                  name="request_category"
                  as="select"
                  className="form-control select2 required"
                >
                  <option>--Select Request Type--</option>
                  {values.request_type.toString() === "2"
                    ? officeRequestsCategories.map((request, i) => (
                        <option value={request.id} key={i}>
                          {request.name}
                        </option>
                      ))
                    : individualRequestsCategories.map((request, i) => (
                        <option value={request.id} key={i}>
                          {request.name}
                        </option>
                      ))}
                </Field>
              </div>
            ) : null}
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Description <span className="text-danger"> * </span>
                  </label>
                  <Field
                    name="description"
                    as="textarea"
                    required="required"
                    cols="10"
                    rows="5"
                    className="form-control"
                  ></Field>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Price <span className="text-danger">*</span>
                  </label>
                  <Field
                    type="number"
                    className="form-control"
                    name="price"
                    required="required"
                  />
                </div>
              </div>
            </div>

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-8">
                {user.roles && user.roles.name === "admin" ? (
                  <button
                    type="submit"
                    className="btn btn-block nt-button-color-default btn-sm"
                  >
                    Update & Approve{" "}
                    {isSubmitting ? (
                      <span
                        id="login_spinner"
                        className="fa fa-spin fa-spinner"
                      ></span>
                    ) : null}
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-block nt-button-color-default btn-sm"
                  >
                    Update
                    {isSubmitting ? (
                      <span
                        id="login_spinner"
                        className="fa fa-spin fa-spinner"
                      ></span>
                    ) : null}
                  </button>
                )}
              </div>
              <div className="col">
                {user.roles && user.roles.name === "admin" ? (
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={rejectRqt}
                  >
                    Reject
                  </button>
                ) : null}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/request/modal/edit_request.js